// extracted by mini-css-extract-plugin
export default {"root":"LocationDetail_root__A0roj"};